<template>
  <div class="navbar">
    <hamburger id="hamburger-container" :is-active="sidebar.opened" class="hamburger-container" @toggleClick="toggleSideBar" />

    <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />

    <div class="right-menu">
      <template v-if="device!=='mobile'">
        <screenfull id="screenfull" class="right-menu-item hover-effect" />
        <div v-show="companyName" class="right-menu-item logout-icon" @click="companyInfoVisible = true">
          <i class="el-icon-info" /> 服务商信息
        </div>
        <div class="right-menu-item logout-icon" @click="handleUpdPassword">
          <i class="el-icon-edit-outline" /> 修改密码
        </div>
        <div class="right-menu-item logout-icon" @click="logout">
          <svg-icon icon-class="password" /> 退出
        </div>
      </template>
    </div>

    <el-dialog title="修改密码" :visible.sync="dialogFormVisible" width="600px" append-to-body :close-on-click-modal="false">
      <el-form
        ref="dataForm"
        v-loading="listLoading"
        :rules="rules"
        :model="temp"
        label-position="right"
        label-width="90px"
        style="margin-left:50px;width:80%"
      >
        <el-form-item label="原密码" prop="password">
          <el-input v-model="temp.password" maxlength="18" type="password" autocomplete="off" show-password />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input v-model="temp.newPassword" type="password" autocomplete="off" minlength="6" maxlength="18" show-password />
        </el-form-item>
        <el-form-item label="确认密码" prop="checkPass">
          <el-input v-model="temp.checkPass" type="password" autocomplete="off" minlength="6" maxlength="18" show-password />
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain @click="dialogFormVisible = false">
          取消
        </el-button>
        <el-button plain type="primary" @click="updatePassword">
          确定
        </el-button>
      </div>
    </el-dialog>

    <el-dialog title="服务商信息" :visible.sync="companyInfoVisible" width="600px" append-to-body :close-on-click-modal="false">
      <el-form
        label-position="right"
        label-width="120px"
        style="margin-left:80px;width:80%"
      >
        <el-form-item label="服务商名称：">
          <span>{{ companyName }}</span>
        </el-form-item>
        <el-form-item v-show="providerNumber" label="服务商编号：">
          <span>{{ providerNumber }}</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button plain type="primary" @click="companyInfoVisible = false">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { updSysUserPassword } from '@/api/gl-user'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import Screenfull from '@/components/Screenfull'
import store from '@/store'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    Screenfull
  },
  data() {
    var validateOldPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入原密码'))
      } else {
        callback()
      }
    }
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'))
      } else {
        if (this.temp.checkPass !== '') {
          this.$refs.dataForm.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.temp.newPassword) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      dialogFormVisible: false,
      listLoading: false,
      // 服务商名称
      companyName: '',
      // 服务商编码
      providerNumber: '',
      companyInfoVisible: false,
      temp: {
        password: '',
        newPassword: '',
        checkPass: ''
      },
      rules: {
        password: [
          { validator: validateOldPass, trigger: 'blur' }
        ],
        newPassword: [
          { validator: validatePass, trigger: 'blur' }
        ],
        checkPass: [
          { validator: validatePass2, trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'device'
    ])
  },
  created() {
    this.getCompanyInfo()
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    async logout() {
      await this.$store.dispatch('user/logout')
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`)
      this.$router.push(`/login`)
    },
    resetTemp() {
      this.temp = {
        password: '',
        newPassword: '',
        checkPass: ''
      }
    },
    handleUpdPassword() {
      this.resetTemp()
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updatePassword() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.listLoading = true
          const tempData = Object.assign({}, this.temp)
          updSysUserPassword(tempData).then(response => {
            this.listLoading = false
            this.dialogFormVisible = false
            if (response.success) {
              this.$notify({ title: '修改成功', message: response.message, type: 'success', duration: 2000 })
            } else {
              this.$notify({ title: '失败', message: response.message, type: 'warning', duration: 2000 })
            }
          }).catch(res => {
            this.listLoading = false
          })
        }
      })
    },
    // 获取服务商信息
    getCompanyInfo() {
      if (store.getters.companyName) {
        this.companyName = store.getters.companyName
      }
      if (store.getters.providerNumber) {
        this.providerNumber = store.getters.providerNumber
      }
      this.hasFuncs = false
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0,21,41,.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background .3s;
    -webkit-tap-highlight-color:transparent;

    &:hover {
      background: rgba(0, 0, 0, .025)
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;
    font-size: 0 !important;

    .logout-icon {
      cursor: pointer;
      font-size: 16px;
      vertical-align: top;
    }

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background .3s;

        &:hover {
          background: rgba(0, 0, 0, .025)
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
